/**
 * Gates app access until the user has made a cookie/tracking consent choice.
 * When consent is not yet given, only the mandatory consent screen is shown.
 */

import React from 'react';
import { useConsent } from '../contexts/ConsentContext';
import ConsentBanner from './ConsentBanner';

export default function ConsentGate({ children }) {
  const { showBanner } = useConsent();

  if (showBanner) {
    return <ConsentBanner fullPage />;
  }

  return children;
}
